<h4>
	{{
		(is2faApp
			? "please_enter_the_verification_code_from_the_app"
			: "please_enter_the_verification_code_that_was_sent_to"
		) | langVal
	}}
</h4>
<div
	class="text-center"
	style="margin: 30px auto; width: 140px"
>
	<app-gen-input
		[actualObj]="this"
		fieldName="otp_token"
		autofocus="autofocus"
		autocomplete="one-time-code"
	/>
	@if (error) {
		<div style="color: red; margin-top: 20px">
			{{ "code_is_not_valid" | langVal }}
		</div>
	}
</div>
<div
	class="text-center"
	style="margin-top: 20px"
>
	<app-btn-ext
		(clickEv)="submit()"
		text="login"
		[isSpin]="isSending"
		iconName="doubleArrow"
	/>
</div>
<div class="text-center">
	@if (apiResponseWasSuccess) {
		<h4>
			{{
				(mode == "regi"
					? "please_wait_while_we_create_your_account"
					: "you_are_now_being_redirected"
				) | langVal
			}}
		</h4>
	}
</div>
